import { inject, Injectable } from '@angular/core';
import { DokaToastService } from '@doka/angular-core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly dokaToastService = inject(DokaToastService);

  async showSuccess(message: string): Promise<void> {
    const toast = await this.dokaToastService.create(
      {
        message,
        title: 'Success',
      },
      'success',
      2,
    );

    toast.show();
  }

  async showError(message: string): Promise<void> {
    const toast = await this.dokaToastService.create(
      {
        message,
        title: 'Error',
      },
      'alert',
    );

    toast.show();
  }
}
